export default async function fetchAll<T extends { id: number }>(
	fetchPage: (page: number, limit: number) => Promise<T[]>,
	limit: number,
): Promise<T[]> {
	const records = new Map<number, T>();
	for (let page = 1; ; page++) {
		// eslint-disable-next-line no-await-in-loop
		const result = await fetchPage(page, limit);
		const previousSize = records.size;
		result.forEach((record) => records.set(record.id, record));
		if (result.length < limit || records.size === previousSize) break;
	}
	return Array.from(records.values());
}
